import { render, staticRenderFns } from "./MessagesAndTasks.vue?vue&type=template&id=06dba993&scoped=true&"
import script from "./MessagesAndTasks.vue?vue&type=script&lang=js&"
export * from "./MessagesAndTasks.vue?vue&type=script&lang=js&"
import style0 from "./MessagesAndTasks.vue?vue&type=style&index=0&id=06dba993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dba993",
  null
  
)

export default component.exports